define('NMSDesignSystem.MainAnalytics', ['GoogleTagManager'], function MainAnalytics(GoogleTagManager) {
    'use strict';

    var installed = false;
    var enabled = false;
    var layerName;
    var measurementId = 'G-19XBGS20Q8';
    var committedLocation = '';
    var previousLocation = '';
    var committedTitle = '';
    var pendingCommitLocation = '';
    var nativeLayout;
    var pending = [];
    var pageEvents = /^(pageView|homeView|cartView|productView|productList|productListEvent|search|checkoutView|selectPayment)$/;
    // These legacy actions already have their own published GA4 ecommerce tags.
    var mappedEvents = /^(login|register|checkoutAsGuest|proceedToCheckout|addToWishlist)$/;
    var mappedActions = /^(Add To Cart|Add To Wishlist|Place Order)$/;

    function command() {
        window[layerName] = window[layerName] || [];
        window[layerName].push(arguments);
    }

    function context(title) {
        return {
            page_location: window.location.href,
            page_title: typeof title === 'string' ? title : committedTitle || document.title,
            page_referrer: previousLocation || document.referrer || ''
        };
    }

    function send(name, parameters) {
        parameters.send_to = measurementId;
        command('event', name, parameters);
    }

    function commitPage(title) {
        var current = window.location.href;
        var parameters;
        if (!enabled || committedLocation === current) {
            return;
        }
        previousLocation = committedLocation;
        parameters = context(title);
        committedLocation = current;
        committedTitle = parameters.page_title;
        // Main's published tag disables automatic page views. One explicit owner
        // supplies the rendered SPA title and URL, including across SCA apps.
        command('set', parameters);
        send('page_view', {
            page_location: parameters.page_location,
            page_title: parameters.page_title,
            page_referrer: parameters.page_referrer
        });
    }

    function install(configuration) {
        var originalPush;
        var originalPageview;
        var originalMount;
        if (!configuration || configuration.id !== 'GTM-N2GQTRQ' ||
            !/^((?:www\.)?nmsincusa\.com|sca-sandbox\.ethanablatt\.com)$/.test(window.location.hostname)) {
            return false;
        }
        if (installed) {
            return true;
        }
        installed = true;
        layerName = configuration.dataLayerName || 'dataLayer';
        originalPush = GoogleTagManager.pushData;
        originalPageview = GoogleTagManager.trackPageview;
        originalMount = GoogleTagManager.mountToApp;

        function renderedTitle(view) {
            var title = view && typeof view.getTitle === 'function' && view.getTitle();
            return typeof title === 'string' ? title : document.title;
        }

        function flushRenderedPage(view) {
            var queue;
            if (!enabled || !pendingCommitLocation ||
                pendingCommitLocation !== window.location.href ||
                nativeLayout && view && nativeLayout.currentView !== view &&
                nativeLayout.modalCurrentView !== view) {
                return;
            }
            pendingCommitLocation = '';
            commitPage(renderedTitle(view));
            queue = pending;
            pending = [];
            queue.forEach(function flushCommittedEvent(entry) {
                if (entry.location === committedLocation) {
                    GoogleTagManager.pushData(entry.data);
                }
            });
        }

        GoogleTagManager.mountToApp = function mountMainAnalytics(application) {
            var layout = application && application.getLayout && application.getLayout();
            if (layout && typeof layout.on === 'function' && nativeLayout !== layout) {
                nativeLayout = layout;
                // Layout tracks before render; Wizard assigns its title during
                // render. Commit after append, before the native GTM loader.
                layout.on('afterAppendView', flushRenderedPage);
            }
            return originalMount.apply(this, arguments);
        };

        GoogleTagManager.pushData = function pushMainAnalytics(data) {
            var parameters;
            if (!enabled) {
                return;
            }
            // The obsolete non-ecommerce trigger sends a custom "Page View".
            // Core's general pageview hook below covers every committed page.
            if (data.event === 'nonEcommercePageView') {
                return;
            }
            if (pageEvents.test(data.event) && typeof data.eventCallback !== 'function' &&
                (pendingCommitLocation || committedLocation !== window.location.href)) {
                // Cart/list hooks run before Layout commits the new page title.
                // Hold only this navigation's events; never replay an abandoned route.
                if (pending.length && pending[0].location !== window.location.href) {
                    pending = [];
                }
                pending.push({location: window.location.href, data: data});
                return;
            }
            originalPush.call(this, data);
            if (data.data && data.data.category && data.data.action &&
                !mappedEvents.test(data.event) && !mappedActions.test(data.data.action)) {
                // Retain legacy-only interactions such as Reorder while retiring
                // Universal Analytics' duplicate forwarding of ecommerce actions.
                parameters = context();
                parameters.event_category = data.data.category;
                parameters.event_label = data.data.label || '';
                if (data.data.value !== '' && isFinite(Number(data.data.value))) {
                    parameters.value = Number(data.data.value);
                }
                send(data.data.action, parameters);
            }
        };

        GoogleTagManager.trackPageview = function trackMainPageview(url) {
            var result;
            if (typeof url !== 'string' || !enabled) {
                return this;
            }
            pendingCommitLocation = window.location.href;
            result = originalPageview.apply(this, arguments);
            if (!nativeLayout) {
                // Keep direct/native integrations without a Layout working.
                flushRenderedPage();
            }
            return result;
        };
        return true;
    }

    return {
        install: install,
        setConsent: function setConsent(value) {
            enabled = installed && value === true;
            if (!enabled) {
                pending = [];
                committedLocation = '';
                previousLocation = '';
                committedTitle = '';
                pendingCommitLocation = '';
            }
        },
        replayCurrentPage: function replayCurrentPage() {
            var view = nativeLayout && (nativeLayout.modalCurrentView || nativeLayout.currentView);
            if (!pendingCommitLocation) {
                commitPage(view && view.getTitle && view.getTitle());
            }
        }
    };
});
